// import Select from "react-select";
// import { Color } from "../../report/visitConstant/Color";

// const DepartmentSelector = ({
//   slectedValue,
//   handleInputChange,
//   departmentItems,
//   inputName,
//   isDisabled = false,
// }) => {
//   const options = departmentItems.map((dept) => ({
//     value: dept.id,
//     label: dept.name,
//   }));

//   return (
//     <div className="col mt-2">
//       <label htmlFor={inputName} className="col-form-label">
//         Department
//       </label>

//       <Select
//         options={options}
//         value={
//           slectedValue
//             ? options.find((option) => option.value === slectedValue)
//             : null
//         }
//         onFocus={() =>
//           handleInputChange({ target: { name: inputName, value: "" } })
//         }
//         isClearable={true}
//         isDisabled={isDisabled}
//         onChange={(selectedOption) =>
//           handleInputChange({
//             target: {
//               name: inputName,
//               value: selectedOption
//                 ? { id: selectedOption.value, name: selectedOption?.label }
//                 : "",
//             },
//           })
//         }
//         className="basic-select"
//         classNamePrefix="select"
//         placeholder="Select Department"
//         styles={{
//           control: (provided, state) => ({
//             ...provided,
//             backgroundColor: isDisabled ? "#e9ecef" : "white", // Light grey when disabled

//             cursor: isDisabled ? "not-allowed" : "default", // Pointer indication
//             boxShadow: state.isFocused
//               ? "0 0 0 0.2rem rgba(130, 80, 255, 0.2)"
//               : null,
//           }),
//           singleValue: (provided) => ({
//             ...provided,
//             color: "black", // Disabled text color
//           }),
//           option: (provided, state) => ({
//             ...provided,
//             backgroundColor: state.isSelected
//               ? Color.primary // Selected option background
//               : state.isFocused
//               ? Color.lightPrimary // Focused option background
//               : "white",
//             color: state.isSelected ? "white" : "black", // Text color
//             cursor: "pointer",
//           }),
//           menu: (provided) => ({
//             ...provided,
//             maxHeight: "110px", // Set the maximum height for the menu
//             overflow: "hidden", // Ensures the scroll works within the defined height
//           }),
//           menuList: (provided) => ({
//             ...provided,
//             maxHeight: "110px", // Height of the scrollable container
//             overflowY: "auto", // Enables vertical scrolling
//           }),
//         }}
//       />
//     </div>
//   );
// };

// export default DepartmentSelector;

import { useState, useEffect } from "react";
import Select from "react-select";
import { Color } from "../../report/visitConstant/Color";
import apiHelper from "../../report/ApiHelpar/apiHelper";
import { GET_ALL_DEPARTME_BY_BRANCH_ID } from "../../report/visitConstant/ApiConstant";
const DepartmentSelector = ({
  selectedValue, // Fixed typo from slectedValue
  handleInputChange,
  inputName,
  isDisabled = false,
  branchId, // New required prop
}) => {
  const [departmentItems, setDepartmentItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getAllDepartmentItems = async () => {
      if (!branchId) {
        setDepartmentItems([]);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const res = await apiHelper(GET_ALL_DEPARTME_BY_BRANCH_ID, {
          branchId,
        });
        const departmentRes = res?.respData?.respMsg;

        if (Array.isArray(departmentRes)) {
          setDepartmentItems(departmentRes);
        } else {
          setDepartmentItems([]);
          console.warn("Unexpected API response format");
        }
      } catch (err) {
        console.error("Error fetching departments:", err);
        setError(err);
        setDepartmentItems([]);
      } finally {
        setIsLoading(false);
      }
    };

    getAllDepartmentItems();
  }, [branchId]);

  const options = departmentItems.map((dept) => ({
    value: dept.id,
    label: dept.name,
  }));

  return (
    <div className="col">
      <label htmlFor={inputName} className="col-form-label">
        Department
        {isLoading && <span className="text-muted ms-2">(Loading...)</span>}
      </label>

      <Select
        options={options}
        value={
          selectedValue // Access the id property
            ? options.find((option) => option.value == selectedValue)
            : null
        }
        onFocus={() =>
          handleInputChange({ target: { name: inputName, value: "" } })
        }
        isClearable={true}
        isDisabled={isDisabled || isLoading || !branchId}
        isLoading={isLoading}
        onChange={(selectedOption) =>
          handleInputChange({
            target: {
              name: inputName,
              value: selectedOption
                ? { id: selectedOption.value, name: selectedOption?.label }
                : "",
            },
          })
        }
        className="basic-select"
        classNamePrefix="select"
        placeholder={
          !branchId
            ? "Select a branch first"
            : isLoading
            ? "Loading departments..."
            : "Select Department"
        }
        styles={{
          control: (provided, state) => ({
            ...provided,
            backgroundColor: isDisabled ? "#e9ecef" : "white",
            cursor: isDisabled ? "not-allowed" : "default",
            boxShadow: state.isFocused
              ? "0 0 0 0.2rem rgba(130, 80, 255, 0.2)"
              : null,
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "black",
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? Color.primary
              : state.isFocused
              ? Color.lightPrimary
              : "white",
            color: state.isSelected ? "white" : "black",
            cursor: "pointer",
          }),
          menu: (provided) => ({
            ...provided,
            maxHeight: "110px",
            overflow: "hidden",
          }),
          menuList: (provided) => ({
            ...provided,
            maxHeight: "110px",
            overflowY: "auto",
          }),
        }}
      />

      {error && (
        <div className="text-danger mt-1">
          Failed to load departments. Please try again.
        </div>
      )}
    </div>
  );
};

export default DepartmentSelector;
